import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getVoucherPayTurnonList, changeVoucherPayTurnon } from "@/api/gmtool/packageCode";
import addCoupon from "./components/addCoupon.vue";
import { gmTool, serchSelect } from "@/mixins/index";
export default {
  name: "couponMarketplace",
  components: {
    addCoupon: addCoupon
  },
  mixins: [gmTool, serchSelect],
  data: function data() {
    return {
      currentPage: 1,
      tableData: [],
      total: 0,
      paramsData: {
        page: 1,
        server_id: '',
        is_prod: ''
      },
      modifyIds: []
    };
  },
  created: function created() {
    this.Renewal();
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this.paramsData.server_id) {
                  _context2.next = 3;
                  break;
                }

                _this.$message.error(_this.$t('pleaseSelectServer'));

                return _context2.abrupt("return");

              case 3:
                _this.reqLoading = true;
                params = JSON.parse(JSON.stringify(_this.paramsData));
                getVoucherPayTurnonList(params).then(function (res) {
                  if (res.result == 1) {
                    _this.tableData = res.turnon_list;
                  } else {
                    _this.$message.error(res.reason);
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    isGetList: function isGetList() {
      if (this.paramsData.server_id) {
        this.getList();
      }
    },
    changeTurnon: function changeTurnon(row) {
      var _this2 = this;

      var params = {
        server_list: this.paramsData.server_id,
        channel_list: row.channel_id,
        turnon: row.turnon,
        is_prod: this.paramsData.is_prod
      };
      changeVoucherPayTurnon(params).then(function (res) {
        if (res.result == 1) {
          _this2.$message({
            type: "success",
            message: _this2.$t('operationSuccess')
          });

          _this2.getList();
        }
      });
    },
    serverChange: function serverChange() {
      if (this.paramsData.server_id) {
        this.getList();
      }
    },
    Renewal: function Renewal() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.paramsData.server_id = '';
                _this3.serverLists = [];
                _context3.next = 4;
                return _this3.getserverList();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};